import qs from "qs";
import authAxios, { authHeader } from "../data";

const fetchAll = async (req: any) => {
  const response = await authAxios.get("/api/ContractDocuments", {
    params: req,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (req: any) => {
  const response = await authAxios.get("/api/ContractDocuments/Count", {
    params: req,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/ContractDocuments/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete(`/api/ContractDocuments/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

const create = async (entry: FormData) => {
  const response = await authAxios.post("/api/ContractDocuments", entry, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (id: string, entry: FormData) => {
  const response = await authAxios.put(`/api/ContractDocuments/${id}`, entry, {
    headers: authHeader(),
  });

  return response.data;
};

const download = async (id: string) => {
  const response = await authAxios.get(
    `/api/ContractDocuments/${id}/download`,
    {
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
      responseType: "blob",
    },
  );

  return response.data;
};

const DocumentsService = {
  fetchAll,
  fetchCount,
  fetch,
  remove,
  create,
  edit,
  download,
};

export default DocumentsService;
